/**
 * Yes No Formatter.
 */
window.yesNoFormatter = function(value, row) {
    if (value === 1 || value === "TRUE") {
        return __('Yes');
    }
    return __('No')
};
